import React from 'react';
import { FirstMenu } from '../../../models/first-menu.entity';
import { BargainPriceItem } from '../../../models/bargain-price-item.entity';
import MenuDishList from '../menu-dish-list/menu-dish-list';
import { apiManage_rbp } from '../../../request';
import GlobalNotification from '../../../component/common/snackbar';
import i18n from '../../../i18n';
import { MenuDish } from '../../../models/menu-dish.entity';
import { Box } from '@mui/material';
import DishSoldOutDetail from './dish-sold-out-detail';
import Card from '../Card';
import { Add, ViewDay } from '@mui/icons-material';
import Table from '../../../component/table/table';
import _ from 'lodash';
import ButtonComponent from '../../../component/button/button.component';
import setLoading from '../../../component/linear-determinate';
import DeleteDialogComponent from '../../../component/dialog/delete-dialog.component';
import { withTranslation } from 'react-i18next';
import { SecondMenu } from '../../../models/second-menu.entity';
import moment from 'moment';
import AlertDialog from '../../../component/dialog/alert-dialog.component';


/**
 * 菜品沽清组件
 */
class DishSoldOutSetting extends React.Component<Props, DishSoldOutSettingState> {
    public MenuDishListRefs: MenuDishList | null = null;
    constructor(props: Props) {
        super(props);
        this.getMenuForSearch = _.debounce(this.getMenuForSearch, 300, {
        }).bind(this) as any;
    }
    public state: DishSoldOutSettingState = {
        isAddDishDialogOpen: false,
        // 原始菜单数据
        originMenuData: [],
        // 菜单数据
        menuData: [],
        // 沽清的菜品
        soldOutDishes: [],
        // 删除弹窗
        deleteDialog: false,

        // 删除的菜品
        currentDish: {},
        // 详情
        details: {},
        // 选中的沽清菜品
        selectDetails: [],
        // 表格每页行数
        rowsPerPage: 20,
        // 当前处理的id
        dishSelectedIds: [],
        // 当前页
        currPage: 0,
        // 当前选中的菜品item
        rowsSelected: [],
        // 搜索款加载
        searchInputLoading: false,
        // 重置沽清弹窗
        resetDialog: false
    }

    // *********************
    // Life Cycle Function
    // *********************

    componentDidMount() {
        this.init()
    }

    // *********************
    // Default Function
    // *********************

    /**
     * 初始化
     */
    async init() {
        try {
            setLoading(true);
            await Promise.all([
                this.getDishSoldOut(),
                this.getMenuData()
            ]).then(results => {
                this.setState({
                    soldOutDishes: this.patchSoldOutDishes(results[0], results[1]),
                    originMenuData: results[1],
                    menuData: results[1]
                })
            })
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }

    /**
     * 获取沽清菜品
     */
    public async getDishSoldOut() {
        try {
            const result = await apiManage_rbp.getDishSoldOut();

            if (!_.get(result, 'error') && result) {
                return result
            }
            else {
                return []
            }
        } catch (error) {
            return []
        }
    }
    /**
     * 获取菜单
     */
    public async getMenuData() {
        const result = await apiManage_rbp.get_menus_v3({
            type: 0,
            with_dish: true,
        })
        return !_.get(result, 'error') ? result : []
    }

    // 设置菜品的一级二级菜单名字
    public patchSoldOutDishes = (dishs: Array<any>, menuData: FirstMenu[]) => {
        dishs.forEach(dish => {
            menuData.find(firstMenu => {
                return firstMenu.menu_item_slu?.find(secondMenu => {
                    return secondMenu.menu_item?.find(item => {
                        if (dish.bargain_item_number === item.item_id || dish.item_id === item.item_id) {
                            dish.bargain_first_menu_name = firstMenu.main_group_name as string
                            dish.bargain_second_menu_name = secondMenu.dmi_slu_name as string
                            dish.bargain_item_name2 = item.item_name2 || ''
                            return true
                        }
                        return false
                    })
                })
            })
        })
        return dishs
    }

    /**
     * 获取关键词菜单
     */
    async getMenuForSearch(value: string) {
        if (value !== '') {
            const data = this.searchDishFunction(this.state.originMenuData || [], value);
            this.setState({
                menuData: this.patchSoldOutDishes(
                    data.filter(item => !this.state.soldOutDishes.find(sd => sd.bargain_item_number === item.item_id)),
                    this.state.originMenuData
                ).map(item => ({
                    main_group_id: item.item_id,
                    main_group_name: `${item.item_name1}----${item.item_name2 || '\xa0\xa0\xa0\xa0\xa0\xa0\xa0'}-----${item.bargain_second_menu_name}-----${item.bargain_first_menu_name}`,
                    type: 'MenuDish',
                    ...item
                })),
            })
        } else {
            this.setState({
                menuData: this.state.originMenuData
            })
        }
    }

    /**
     * 搜索菜品数据函数
     */
    searchDishFunction(menu: FirstMenu[], value: string) {
        const newDish: MenuDish[] = []
        menu.forEach((firstMenu) => {
            (firstMenu?.menu_item_slu as SecondMenu[] || []).forEach((secondMenu) => {
                (secondMenu?.menu_item as MenuDish[] || []).forEach((dish   ) => {
                    if (dish.item_name1?.toUpperCase().includes(value.toUpperCase()) ||
                        dish.item_name2?.toUpperCase().includes(value.toUpperCase())
                    ) {
                        newDish.push(dish)
                    }
                })
            })
        })
        if (newDish.length) {
            return newDish
        }
        else {
            GlobalNotification.warning(i18n.t('dish_sold_out_page_menu_and_dishes_page_z_dish_no_have_match'));
            return []
        }
    }

    /**
     * 删除
     */
    async handleDeleteDish() {
        try {
            const ids = this.state.dishSelectedIds;
            if (ids && ids.length) {
                setLoading(true);
                const result = await apiManage_rbp.delDishSoldOut(ids);
                if (!result.error) {
                    const soldOutDishes = await this.getDishSoldOut();
                    this.setState({
                        soldOutDishes: this.patchSoldOutDishes(soldOutDishes, this.state.originMenuData),
                        rowsSelected: []
                    })
                    GlobalNotification.success(i18n.t('google_text_delete_success'));
                } else {
                    GlobalNotification.error(i18n.t('google_text_delete_failed'));
                }
                setLoading(false);
            }
        } catch (error) { }
    }
    /**
     * 重置沽清菜品
     */
    async handleResetBargainDish() {
        try {
            const ids = this.state.dishSelectedIds;
            if (ids && ids.length) {
                setLoading(true);
                const result = await apiManage_rbp.patchDishBargainNum({ bargainIds: ids });
                if (!result.error) {
                    const soldoutDishes = await this.getDishSoldOut();
                    if (this.state.details?.bargain_item_id) {
                        // 返回列表页
                        this.setState({
                            soldOutDishes: this.patchSoldOutDishes(soldoutDishes, this.state.originMenuData),
                            rowsSelected: [],
                            details: {}
                        })
                    } else {
                        this.setState({
                            soldOutDishes: this.patchSoldOutDishes(soldoutDishes, this.state.originMenuData),
                            rowsSelected: [],
                        })
                    }

                    GlobalNotification.success(i18n.t('global_text_operate_success'));
                } else {
                    GlobalNotification.error(i18n.t('global_text_operate_failure'));
                }
                setLoading(false);
            }
        } catch (error) { }
    }


    filterDish(dishes: BargainPriceItem[]) {
        const dishIds: number[] = [];
        if (dishes.length) {
            for (const i in dishes) {
                if (dishes[i]) {
                    dishIds.push(dishes[i].bargain_item_number || 0)
                }
            }
        }
        return dishIds;
    }

    /**
     * 保存沽清菜品
     */
    async onSave(isSkipNotice: boolean = false) {
        const { details, selectDetails } = this.state;
        if (details) {
            if (!details.bargain_item_number) {
                GlobalNotification.error(i18n.t('dish_sold_out_page_please_select_sell_out_dishe'))
                return
            }
            if (!isSkipNotice && details.bargain_item_id === -1) {
                // TODO 沽清菜品影响套餐弹窗
            }

            let _bargainStartDate;
            let _bargainEndDate;
            if (Number(details.bargain_stype) === 3) {
                _bargainStartDate = moment(new Date()).format('YYYY-MM-DD');
                _bargainEndDate = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
            }
            const params = {
                // 菜品名称
                bargain_item_name: details.bargain_item_name,
                bargain_item_number: details.bargain_item_number,
                // 沽清类型（0不沽清；1手动沽清；2数量沽清；3当日沽清
                bargain_stype: Number(details.bargain_stype),
                // 可用数量
                bargain_num_cur: Number(details.bargain_num_cur || 0),
                // 可销售数量
                bargain_num: Number(details.bargain_num || 0),
                // 日结后恢复数量
                is_every_day: Number(details.is_every_day || 0 as number),
                // 当日沽清开始时间(非当日沽清不传)
                bargain_start_date: _bargainStartDate,
                // 当日沽清结束时间(非当日沽清不传)
                bargain_end_date: _bargainEndDate,
            }
            const id = _.cloneDeep(details.bargain_item_id);
            this.setState({ details: {} });
            if (id !== -1) {
                const res = await apiManage_rbp.patchDishSoldOut(`${id}`, params);
                if (!res?.error) {
                    GlobalNotification.success(i18n.t('google_text_edit_succeed'));
                } else {
                    GlobalNotification.error(i18n.t('google_text_edit_failed'));
                }
            } else {
                // $ 新增沽清菜品操作可批量
                const addParams = selectDetails.map(n => {
                    let _curBargainStartDate;
                    let _curBargainEndDate;
                    if (Number(n.bargain_stype) === 3) {
                        _curBargainStartDate = moment(new Date()).format('YYYY-MM-DD');
                        _curBargainEndDate = moment(new Date()).add(1, 'days').format('YYYY-MM-DD');
                    }
                    const param = {
                        // 菜品名称
                        bargain_item_name: n.bargain_item_name,
                        bargain_item_number: n.bargain_item_number as number,
                        // 沽清类型（0不沽清；1手动沽清；2数量沽清；3当日沽清
                        bargain_stype: Number(n.bargain_stype),
                        // 可用数量
                        bargain_num_cur: Number(n.bargain_num_cur || 0),
                        // 可销售数量
                        bargain_num: Number(n.bargain_num || 0),
                        // 日结后恢复数量
                        is_every_day: Number(n.is_every_day || 0 as number),
                        // 当日沽清开始时间(非当日沽清不传)
                        bargain_start_date: _curBargainStartDate,
                        // 当日沽清结束时间(非当日沽清不传)
                        bargain_end_date: _curBargainEndDate,
                    }
                    return param
                });
                const res = await apiManage_rbp.postDishSoldOut(addParams)
                if (!res?.error) {
                    GlobalNotification.success(i18n.t('dish_sold_out_page_add_succeed'));
                } else {
                    GlobalNotification.error(i18n.t('dish_sold_out_page_add_failed'));
                }
            }
            const soldOutDishes = await this.getDishSoldOut();
            this.setState({
                soldOutDishes: this.patchSoldOutDishes(soldOutDishes, this.state.originMenuData),
                details: {}
            })
            // setLinearLoading(false);
        }
    }

    /**
     * 添加沽清菜品
     */
    async onSelectDish(items: MenuDish[]) {
        const item = items?.[0] || {};
        const afterSelectDetails = items.map(n => {
            const param = {
                ...this.state.details,
                bargain_item_name: n.item_name1,
                bargain_item_number: n.item_id,
            }
            return param
        })
        this.setState((state) => ({
            selectDetails: afterSelectDetails,
            details: {
                ...state.details,
                bargain_item_name: item.item_name1,
                bargain_item_number: item.item_id,
            }
        }))
    }

    /**
     * 重置沽清
     * @param resetDataIds
     */
    handleResetSellOut(dishSelectedIds: number[]) {
        this.setState({
            resetDialog: true,
            dishSelectedIds
        })
    }


    /**
     * 选中项，表格头部工具栏显示
     * @returns
     */
    public handleTableToolbarSelectRender(
        selectedRows: { data: Array<{ index: number; dataIndex: number }>; lookup: { [key: number]: boolean } }
    ): React.ReactNode {
        // 选中的数据
        const dishSelected = selectedRows.data.map((item) => (_.get(this.state.soldOutDishes, `[${item.dataIndex}].bargain_item_id`, 0)));
        return (
            <Box padding={'4px 12px'}>
                <ButtonComponent
                    titleText={i18n.t('order_cart_page_text_reset_dish_sold_out')}
                    handleClick={() => this.handleResetSellOut(dishSelected)}
                >
                    <ViewDay />
                </ButtonComponent>
                <ButtonComponent
                    action='DELETE'
                    handleClick={() => {
                        this.setState({
                            deleteDialog: true,
                            dishSelectedIds: dishSelected
                        })
                    }}
                />
            </Box>
        )
    }

    /**
     * 沽清类型文字
     * @param sta 沽清类型（0不沽清；1手动沽清；2数量沽清；3当日沽清）
     * @returns
     */
    public getStypeValue = (value: number) => {
        const text = new Map([
            [1, i18n.t('dish_sold_out_page_manual_sell_out')],
            [2, i18n.t('dish_sold_out_page_amount_sell_out')],
            [3, i18n.t('dish_sold_out_page_day_sell_out')]
        ]);
        return text.get(value) ?? ''
    }

    render() {
        const columns = [
            {
                name: 'bargain_item_id',
                label: 'id',
                options: {
                    sort: false,
                }
            },
            {
                name: 'bargain_stype',
                label: i18n.t('dish_sold_out_page_sell_out_type'),
                options: {
                    sort: false,
                    customBodyRenderLite: (dataIndex: number) => {
                        return (
                            <div>
                                {this.getStypeValue(soldOutDishes[dataIndex].bargain_stype ?? 0)}
                            </div>
                        )
                    }
                }
            },
            {
                name: 'bargain_item_name',
                label: i18n.t('base_setting_dish_name'),
                options: {
                    sort: false
                }
            },
            {
                name: 'bargain_item_name2',
                label: i18n.t('menu_and_dishes_page_dish_name2'),
                options: {
                    sort: false
                }
            },
            {
                name: 'bargain_first_menu_name',
                label: i18n.t('menu_and_dishes_page_group_name'),
                options: {
                    sort: false
                }
            },
            {
                name: 'bargain_second_menu_name',
                label: i18n.t('menu_and_dishes_page_secondary_menu_name'),
                options: {
                    sort: false
                }
            }
        ];
        const { menuData, soldOutDishes, deleteDialog, details, selectDetails, rowsPerPage, resetDialog } = this.state;
        return (
            <Box className='dish-sold-out-page'>
                {details?.bargain_item_id
                    ?
                    <DishSoldOutDetail
                        detail={details}
                        selectDetails={details?.bargain_item_id === -1 ? selectDetails : [details]}
                        getData={() => { this.setState({ details: {} }) }}
                        updateState={(newState: Pick<DishSoldOutSettingState, keyof DishSoldOutSettingState>) => { this.setState(newState) }}
                        onSave={async () => {
                            this.onSave()
                            this.setState({
                                menuData: this.state.originMenuData
                            })
                        }}
                        onResetSellOut={() => this.handleResetSellOut([details?.bargain_item_id ?? 0])}
                        menuData={menuData}
                        // 编辑单选 ， 新增多选
                        isRadio={details?.bargain_item_id !== -1}
                        isSellOut={true}
                        getMenuForSearch={(value) => { this.getMenuForSearch(value); }}
                        filterDishArr={this.filterDish(soldOutDishes || [])}
                        onClose={() => {
                            this.setState({
                                menuData: this.state.originMenuData
                            })
                        }}
                    />
                    :
                    <Card
                        className={'card-dishes'}
                        title={(
                            <Box display='flex' alignItems='center'>
                            </Box>
                        )}
                        actionRender={(
                            <ButtonComponent
                                titleText={i18n.t('google_text_newly_increased')}
                                children={<Add />}
                                handleClick={() => {
                                    this.MenuDishListRefs?.clearSelected();
                                    this.setState({
                                        details: {
                                            bargain_item_id: -1,
                                            bargain_stype: 1
                                        }
                                    })
                                }}
                            />
                        )}
                        contentRender={(
                            <Box>
                                <Table
                                    data={soldOutDishes || []}
                                    columns={columns}
                                    rowsSelected={this.state.rowsSelected}
                                    onRowSelectionChange={(currentRowsSelected: any[], allRowsSelected: any[], rowsSelected?: any[]) => {
                                        this.setState({
                                            rowsSelected: rowsSelected || []
                                        })
                                    }}
                                    rowsPerPage={rowsPerPage}
                                    onChangeRowsPerPage={(nums: number) => {
                                        this.setState({
                                            rowsPerPage: nums,
                                        })
                                    }}
                                    pagination={true}
                                    selectableRowsHideCheckboxes={false}
                                    selectableRowsHeader={true}
                                    selectToolbarPlacement='replace'
                                    onCellClick={(colData, cellMeta: {
                                        colIndex: number;
                                        rowIndex: number;
                                        dataIndex: number;
                                        event: React.MouseEvent<Element, MouseEvent>;
                                    }) => {
                                        const rowsSelectedItem = soldOutDishes.find((item, index) => index === cellMeta.dataIndex) || {};
                                        this.MenuDishListRefs?.clearSelected();
                                        this.setState({
                                            details: {
                                                ...rowsSelectedItem,
                                                is_every_day: (rowsSelectedItem.is_every_day as { data: number[] })?.data?.[0] || 0
                                            }
                                        })
                                    }}
                                    otherOption={{
                                        customToolbarSelect: (
                                            selectedRows,
                                        ): React.ReactNode => {
                                            return this.handleTableToolbarSelectRender(selectedRows);
                                        },
                                        page: this.state.currPage,
                                        onChangePage: (page: number) => {
                                            this.setState({ currPage: page })
                                        },
                                    }}
                                />
                            </Box>
                        )}
                    />
                }
                {
                    deleteDialog &&
                    <DeleteDialogComponent
                        {...{
                            title: i18n.t('google_text_public_button_delete'),
                            open: true,
                            onCancel: () => {
                                this.setState({
                                    deleteDialog: false
                                })
                            },
                            onConfirm: async () => {
                                await this.handleDeleteDish()
                                this.setState({
                                    deleteDialog: false
                                })
                            },
                        }}
                    />
                }


                {resetDialog ?
                    <AlertDialog
                        open={true}
                        title={i18n.t('general_text_tips')}
                        desc={i18n.t('order_cart_page_text_reset_dish_sold_out_notice_message')}
                        onCancel={() => {
                            this.setState({
                                resetDialog: false
                            })
                        }}
                        onConfirm={() => {
                            this.setState({
                                resetDialog: false
                            }, () => {
                                this.handleResetBargainDish()
                            })
                        }}
                    />
                    :
                    null}

            </Box>
        )
    }
}

export default withTranslation()(DishSoldOutSetting);

// *********************
// Type
// *********************
export type DishSoldOutSettingState = {
    originMenuData: Array<FirstMenu>;
    menuData: Array<FirstMenu>;
    isAddDishDialogOpen: boolean;
    soldOutDishes: Array<BargainPriceItem>;
    deleteDialog: boolean;
    currentDish: BargainPriceItem;
    details: BargainPriceItem;
    // 选中的沽清菜品
    selectDetails: BargainPriceItem[];
    // 表格每页行数
    rowsPerPage: number;
    // 当前处理的id
    dishSelectedIds: number[];
    // 当前页
    currPage: number;
    // 当前选中的菜品item
    rowsSelected: any[];
    // 搜索款加载
    searchInputLoading: boolean;
    // 重置沽清弹窗
    resetDialog: boolean;
}

type Props = {}



